




































import Vue, { PropType } from 'vue';
import { http } from '@/util/HTTP';
type CommerceBranch = { branch_id: string; commerce_id: string };
export default Vue.extend({
  name: 'CommerceBranchSelect',
  props: {
    companyId: {
      type: String,
      required: true,
    },
    value: {
      type: Object as PropType<CommerceBranch>,
      required: true,
    },
    withCommerceId: {
      type: Boolean,
      default: true,
    },
    withBranchId: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      http,
    };
  },
  watch: {
    companyId(newVal: string, oldVal: string) {
      // Reset commerce and branch when company changes
      if (newVal !== oldVal && oldVal !== undefined) {
        this.syncedFilters = { commerce_id: '', branch_id: '', };
      }
    },
  },
  methods: {
    onSelectCommerce(val: string) {
      // Al cambiar comercio, resetea branch y dispara el setter
      this.syncedFilters = { commerce_id: val, branch_id: '', };
      this.emitName('commerce_name', this.commerceUrl, val);
      // Branch was reset, so clear its resolved name too.
      this.$emit('change-names', { branch_name: '', });
    },
    onSelectBranch(val: string) {
      // Al cambiar branch, dispara el setter
      this.syncedFilters = { ...this.syncedFilters, branch_id: val, };
      this.emitName('branch_name', this.branchUrl, val);
    },
    /**
     * Resolves the display name for a freshly selected id and emits it via
     * `change-names`. Additive — consumers that don't listen are unaffected.
     * Uses the same `id_eq[]` lookup the underlying server-select relies on.
     */
    async emitName(
      key: 'commerce_name' | 'branch_name',
      baseUrl: string,
      id: string
    ): Promise<void> {
      if (!id) {
        this.$emit('change-names', { [key]: '', });
        return;
      }
      try {
        const separator = baseUrl.includes('?') ? '&' : '?';
        const { data, } = await this.http.get(`${baseUrl}${separator}id_eq[]=${id}`);
        const list = (data && data.data) || [];
        const match = list.find((item: { id: string }) => item.id === id);
        this.$emit('change-names', { [key]: (match && match.name) || '', });
      } catch (error) {
        // Name is optional metadata; never block selection on a failed lookup.
        this.$emit('change-names', { [key]: '', });
      }
    },
  },
  computed: {
    commerceUrl(): string {
      return `/backoffice/companies/${this.companyId}/commerces`;
    },
    branchUrl(): string {
      return `/backoffice/commerces/${this.syncedFilters.commerce_id}/branches?company_id_eq=${this.companyId}`;
    },
    defaultCommerceOptions(): string[] {
      return this.syncedFilters.commerce_id ? [this.syncedFilters.commerce_id] : [];
    },
    defaultBranchOptions(): string[] {
      return this.syncedFilters.branch_id ? [this.syncedFilters.branch_id] : [];
    },
    syncedFilters: {
      get(): CommerceBranch {
        return this.value;
      },
      set(value: CommerceBranch): void {
        this.$emit('input', value);
      },
    },
  },
});
